import React from "react";
import { Grid, Row, Col } from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import PartnerForm from "./PartnerForm";

const PartnerFormPage = ({
  title,
  submitLabel,
  submittingLabel,
  onSubmit,
  onBack,
  message,
  messageType,
  submitting,
  ...formProps
}) => (
  <Grid fluid>
    <Row>
      <Col md={12}>
        <Card
          title={title}
          content={
            <form onSubmit={onSubmit} noValidate>
              {message && (
                <div className={"alert alert-" + messageType}>{message}</div>
              )}
              <PartnerForm {...formProps} disabled={submitting} />
              <Button bsStyle="info" fill type="submit" disabled={submitting}>
                {submitting ? submittingLabel : submitLabel}
              </Button>
              <Button
                bsStyle="default"
                type="button"
                className="partners-back-button"
                onClick={onBack}
              >
                <i className="fa fa-arrow-left" />
                Back to Service Partner List
              </Button>
            </form>
          }
        />
      </Col>
    </Row>
  </Grid>
);

export default PartnerFormPage;
